import { DxFlow_Obj_Property } from '../models/domain/dxflow_obj_property';

export class DxFlow_Obj_PropertiesUtil {
    private static instance: DxFlow_Obj_PropertiesUtil;

    static getInstance() {
        if (!DxFlow_Obj_PropertiesUtil.instance) {
            DxFlow_Obj_PropertiesUtil.instance = new DxFlow_Obj_PropertiesUtil();
        }

        return DxFlow_Obj_PropertiesUtil.instance;
    }

    /**
    * DxFlow_Obj_PropertiesUtil is a singleton class, so use DxFlow_Obj_PropertiesUtil.getInstance() method instead of creating new DxFlow_Obj_PropertiesUtil().
    */
    private constructor() {

    }

    getPrimaryKey(dxFlow_Obj_Property: DxFlow_Obj_Property): string {
        return dxFlow_Obj_Property.dxFlow_Id + '-' +
            dxFlow_Obj_Property.job_Id + '-' +
            dxFlow_Obj_Property.property_Id + '-' +
            dxFlow_Obj_Property.property_Cd + '-' +
            dxFlow_Obj_Property.property_Nm + '-' +
            dxFlow_Obj_Property.property_Val + '-' +
            dxFlow_Obj_Property.srt_Order + '-' +
            dxFlow_Obj_Property.property_Type;
    }

    diffDxFlow_Obj_Properties(dxFlow_Obj_Properties, dxFlow_Obj_PropertiesCopy) {

        if (dxFlow_Obj_Properties.length != dxFlow_Obj_PropertiesCopy.length)
            return 'Length mismatch';

        let dxFlow_Obj_PropertiesCopyHMap = [];
        for (let i = 0; i < dxFlow_Obj_PropertiesCopy.length; i++) {
            dxFlow_Obj_PropertiesCopyHMap[dxFlow_Obj_PropertiesCopy[i].property_Cd] = dxFlow_Obj_PropertiesCopy[i];
        }

        let dxFlow_Obj_Property;
        let dxFlow_Obj_Propertystring;

        let dxFlow_Obj_PropertyCopy;
        let dxFlow_Obj_PropertyCopyString;
        for (let i = 0; i < dxFlow_Obj_Properties.length; i++) {
            dxFlow_Obj_Property = dxFlow_Obj_Properties[i];

            dxFlow_Obj_PropertyCopy = dxFlow_Obj_PropertiesCopyHMap[dxFlow_Obj_Property.property_Cd];
            if (!dxFlow_Obj_PropertyCopy) return 'dxFlow_Obj_Property Not Found';

            dxFlow_Obj_Propertystring = this.toString(dxFlow_Obj_Property)


            dxFlow_Obj_PropertyCopyString = this.toString(dxFlow_Obj_PropertyCopy)

            if (dxFlow_Obj_Propertystring != dxFlow_Obj_PropertyCopyString)
                return 'dxFlow_Obj_Properties are not Equal';
        }

        return '';
    }

    copy(dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>): Array<DxFlow_Obj_Property> {
        let dxFlow_Obj_PropertiesCopy: Array<DxFlow_Obj_Property> = new Array<DxFlow_Obj_Property>();

        for (let i: number = 0; i < dxFlow_Obj_Properties.length; i++) {
            dxFlow_Obj_PropertiesCopy.push(dxFlow_Obj_Properties[i].copy())
        }

        return dxFlow_Obj_PropertiesCopy;
    }

    copyFrom(dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>, dxFlow_Obj_PropertiesTmp: Array<DxFlow_Obj_Property>): void {
        let dxFlow_Obj_PropertiesMap: Map<string, DxFlow_Obj_Property> = new Map();

        let dxFlow_Obj_PropertiesLength: number = dxFlow_Obj_Properties.length;
        for (let i: number = 0; i < dxFlow_Obj_PropertiesLength; i++) {
            dxFlow_Obj_PropertiesMap.set(this.getPrimaryKey(dxFlow_Obj_Properties[i]), dxFlow_Obj_Properties[i]);
        }

        dxFlow_Obj_Properties.splice(0, dxFlow_Obj_Properties.length);

        let dxFlow_Obj_PropertiesTmpLength: number = dxFlow_Obj_PropertiesTmp.length;
        for (let i: number = 0; i < dxFlow_Obj_PropertiesTmpLength; i++) {
            let dxFlow_Obj_PropertyTmp: DxFlow_Obj_Property = dxFlow_Obj_PropertiesTmp[i] as DxFlow_Obj_Property;
            let dxFlow_Obj_Property: DxFlow_Obj_Property = dxFlow_Obj_PropertiesMap.get(this.getPrimaryKey(dxFlow_Obj_PropertyTmp));
            if (dxFlow_Obj_Property) {
                dxFlow_Obj_Property.copyFrom(dxFlow_Obj_PropertyTmp);
            } else {
                dxFlow_Obj_Property = DxFlow_Obj_Property.parse(dxFlow_Obj_PropertyTmp);
            }

            dxFlow_Obj_Properties.push(dxFlow_Obj_Property);
        }
    }

    compare(dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>, dxFlow_Obj_PropertiesTmp: Array<DxFlow_Obj_Property>): string {
        let dxFlow_Obj_PropertiesLength = dxFlow_Obj_Properties.length;
        let dxFlow_Obj_PropertiesTmpLength = dxFlow_Obj_PropertiesTmp.length;

        if (dxFlow_Obj_PropertiesLength != dxFlow_Obj_PropertiesTmpLength) {
            return 'dxFlow_Obj_Properties length is different.';
        }

        for (let i: number = 0; i < dxFlow_Obj_PropertiesLength; i++) {
            if (dxFlow_Obj_Properties[i].compare(dxFlow_Obj_PropertiesTmp[i]) != '') {
                return "dxFlow_Obj_Properties [" + i + '] is not equal.'
            }
        }

        return '';
    }

    toString(dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>): string {
        let str: string = 'Db_PropertyTypes length: ' + dxFlow_Obj_Properties.length + ' ';

        for (let i: number = 0; i < dxFlow_Obj_Properties.length; i++) {
            str += dxFlow_Obj_Properties[i].toString();
        }

        return str;
    }
}    
